

export const questiontypes = {
  'SC1-3': {
    type: 'XVdropdown'
  },
  'SC1-4': {
    type: 'XVdropdown'
  },
  'SC1-5': {
    type: 'XVdropdown'
  },
  'SC1-6': {
    type: 'XVdropdown'
  },
  'SC1-7': {
    type: 'XVdropdown'
  },
  'SC1-8': {
    type: 'XVdropdown'
  },
  'SC1-9': {
    type: 'XVdropdown'
  },
  'SC1-10': {
    type: 'XVdropdown'
  },
  'TxtLn': {
    type: 'XVinput'
  },
  'TxtArea': {
    type: 'XVtextarea'
  },
  'YN': {
    type: 'XVdropdown'
   },
  'MSSC': {
    type: 'XVdropdown'
  },
  'Time': {
    type: 'XVtime'
  },
  'Date': {
    type: 'XVdate'
  },
  'Number': {
    type: 'XVinput'
  },
  'SC1-3#r': {
    type: 'XVradiobuttonlist'
  },
  'SC1-4#r': {
    type: 'XVradiobuttonlist'
  },
  'SC1-5#r': {
    type: 'XVradiobuttonlist'
  },
  'SC1-6#r': {
    type: 'XVradiobuttonlist'
  },
  'SC1-7#r': {
    type: 'XVradiobuttonlist'
  },
  'SC1-8#r': {
    type: 'XVradiobuttonlist'
  },
  'SC1-9#r': {
    type: 'XVradiobuttonlist'
  },
  'SC1-10#r': {
    type: 'XVradiobuttonlist'
  },
  'horizontalradiolist': {
    type: 'XVradiobuttonlistHorizontal'
    // type: 'XVsterrencontrol'
  },
  'YN#r': {
    type: 'XVradiobuttonlist'
  },
  'MSMC': {
    type: 'XVcheckboxlist'
  },
  'MultiTxtLn#3': {
  },
  'MultiTxtLn#4': {
  },
  'DateTime': {
  },
  'SterrenBeoordeling': {
    type: 'XVsterrencontrol'
  }
}
